<template>

  <div v-if="printProject" class="web-print-header">
    <div class="web-print-title">{{ (printProject.altname ? printProject.altname + ' · ' : '') + printProject.name + (printProject.description ? ' · ' + printProject.description : '') }}</div>
    <div class="web-print-meta">
      <span>Personalplan Ausgabedatum </span><strong>{{ formatDateDDMMYYYY(new Date(), '.') }}</strong>
      <span class="web-print-sep">Zeitraum:</span><strong>{{ formatDateDDMMYYYY(startDate, '.') }} – {{ formatDateDDMMYYYY(endDate, '.') }}</strong>
    </div>
  </div>

  <div  class="scheduler-wrapper">

	<div ref="cornerRef">	<Corner :printProject="printProject"
            :configs="props.configs" :projectFilter="projectFilter" @setProjectFilter="handleSetProjectFilter" @zoom="handleZoom" />
    </div>
    <div ref="sidebarRef" :style="{height: printProject ? 'fit-content' : 'auto'}" :class="{printview: printProject}" class="sidebar" id="sidebar"  @scroll="syncScroll('left')">
		<template v-for="(p, i) in displayProjects" :key="`kopf-${p.id}`">
		<!-- Trenner zwischen aktiven und potentiellen Projekten (Wunsch Hoffi).
		     Bewusst NICHT als Zeile in displayProjects: sonst muesste jede Stelle,
		     die ueber die Liste laeuft, ein Gebilde aussortieren, das kein Projekt
		     ist - genau das Muster, das die Kategoriezeilen so teuer gemacht hat. -->
		<div v-if="istGruppenwechsel(i)" class="gruppentrenner sidebar-trenner">
		  Potentielle Projekte
		</div>
		<ProjectHeader
		    :abstandUnten="istBlockEnde(i)"
		    :project="p"
	         :isprintView="printProject || false"
			:users="props.users"
			:bookings="displayBookings"
			:projects="props.projects"
			:isopen="view.isOpenProject(p.id)"
			:resourceFilter="resourceFilter[p.id]"
			@updateResourceFilter="handleUpdateResourceFilter"
			@update="updateProjectOpenstates"
			@print-view="handlePrintAction"
			@addSubproject="oeffneUnterprojektDialog"
		  />
		</template>
	</div>
    <div ref="timesheetRef" class="main-scroll-area" id="main-scroll-area"  @scroll="syncScroll('right')">
      <Timeaxis :key="`${startDate.getTime()}-${endDate.getTime()}`" :printProject="printProject" :visibleUserIds="printProject ? resourceFilter[printProject.id]?.visible : null" :startDate="startDate" :endDate="endDate" @deselect="closeSelection" :bookings="displayBookings"/>
	  <div class="timesheet" id="timesheet">
	    <template v-for="(p, i) in displayProjects"
	              :key="`zeile-${p.id}-${startDate.getTime()}-${endDate.getTime()}`">
	    <!-- Dieselbe Hoehe wie in der Seitenleiste, sonst laufen die beiden
	         Spalten auseinander. -->
	    <div v-if="istGruppenwechsel(i)" class="gruppentrenner"></div>
	    <ProjectTimesheet
		  :startDate="startDate"
		  :endDate="endDate"
	      :project="p"
	      :isprintView="(printProject && printProject.id === p.id) || false"
	      :projects="props.projects"
	      :users="props.users"
	      :bookings="displayBookings"
	      :isopen="view.isOpenProject(p.id)"
	      :resourceFilter="resourceFilter[p.id]"
	      :subRows="subRowCounts[p.id] || 0"
	      :configs="props.configs"
	      @bookingDone="handleBookingDone"
	      @projectChangeDone="projectChangeDone"
	      @cancel="handleCancel"
	      @deselect="closeSelection"
	    />
	    </template>
	    <HighlightDays :startDate="startDate" :endDate="endDate" :isprintView="printProject !== null" :configs="props.configs" />
	    <div v-if="!printProject" id="today-line" class="today-line"> </div>
	    <div v-if="!printProject" id="selection-layer" class="selection-layer"></div>
	  </div>
    </div>
	
	<Callout id="projecttimePopup" :target="popupTarget" :show="showPopup" :arrow="true" @close="closePopup" >

	  <!-- Context menu: only for bookings -->
	  <div v-if="popupMode === 'context'" style="min-width: 200px;" class="flex flex-col gap-2">
	    <p style="font-size: 11px; color: #888; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; padding: 0 2px;">Buchung ändern</p>
	    <button class="w-full text-center px-3 py-2 text-sm bg-timin hover:brightness-90 rounded text-black" @click="popupMode = 'datechange'">Zeitraum ändern</button>
	    <button class="w-full text-center px-3 py-2 text-sm bg-timin hover:brightness-90 rounded text-black" @click="popupMode = 'moveproject'">In anderes Projekt verschieben</button>
	    <button class="w-full text-center px-3 py-2 text-sm bg-timin hover:brightness-90 rounded text-red-600 font-medium" @click="handleDeleteFromContext">Buchung löschen</button>
	  </div>

	  <!-- Zeitabschnitte eines Projekts (TIM-38): beliebig viele, dazwischen Pausen -->
	  <div v-if="popupMode === 'datechange' && popupType === 0" style="min-width: 300px;">
	    <p>Projektzeitraum ändern</p>
	    <div v-for="(row, i) in periodRows" :key="`period-${i}`" class="flex flex-wrap items-center gap-1.5 mb-1.5">
	      <DateInput label="von" :modelValue="row.start" @datechange="(v) => row.start = v" />
	      <DateInput label="bis" :modelValue="row.end" @datechange="(v) => row.end = v" />
	      <button v-if="periodRows.length > 1"
	              class="px-1.5 py-1 rounded border border-gray-300 hover:bg-gray-100 text-gray-600 text-sm leading-none"
	              title="Abschnitt entfernen"
	              @click="periodRows.splice(i, 1)">−</button>
	    </div>
	    <button class="text-sm text-gray-600 hover:underline mb-2" @click="addPeriodRow()">+ Abschnitt</button>
	    <p class="text-xs text-gray-500 mb-2">Pausen unter einer Woche werden zusammengefasst.</p>
	    <button
	      class="w-full flex items-center space-x-2 text-center timin_text_center px-3 py-2 bg-timin hover:brightness-90 text-black"
	      @click="handlePeriodsApply()"
	    >
	      <span>Anwenden</span>
	    </button>
	  </div>

	  <!-- Date change popup: bookings -->
	  <div v-if="popupMode === 'datechange' && popupType === 1">
	    <p>Buchungszeitraum ändern</p>
	    <div style="display:flex; align-items:center; gap:4px;">
	      <button @click="handleStartDateChange(shiftDate(entityStartDate, -1))" class="px-1.5 py-1 rounded border border-gray-300 hover:bg-gray-100 text-gray-600 text-sm leading-none">‹</button>
	      <DateInput label="Start" :modelValue="entityStartDate" :max="entityEndDate" @datechange="handleStartDateChange" />
	      <button @click="handleStartDateChange(shiftDate(entityStartDate, 1))" class="px-1.5 py-1 rounded border border-gray-300 hover:bg-gray-100 text-gray-600 text-sm leading-none">›</button>
	    </div>
	    <div class="spacer"/>
	    <div style="display:flex; align-items:center; gap:4px;">
	      <button @click="handleEndDateChange(shiftDate(entityEndDate, -1))" class="px-1.5 py-1 rounded border border-gray-300 hover:bg-gray-100 text-gray-600 text-sm leading-none">‹</button>
	      <DateInput label="Ende" :modelValue="entityEndDate" :min="entityStartDate" @datechange="handleEndDateChange" />
	      <button @click="handleEndDateChange(shiftDate(entityEndDate, 1))" class="px-1.5 py-1 rounded border border-gray-300 hover:bg-gray-100 text-gray-600 text-sm leading-none">›</button>
	    </div>
	    <div class="spacer"/>
	    <button
	      class="w-full flex items-center space-x-2 text-center timin_text_center px-3 py-2 bg-timin hover:brightness-90 text-black"
	      @click="handleDateChangeApply()"
	    >
	      <span>Anwenden</span>
	    </button>
	  </div>

	  <!-- Move project popup: bookings only -->
	  <div v-if="popupMode === 'moveproject'">
	    <p style="font-size: 11px; color: #888; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 6px;">In Projekt verschieben</p>
	    <div style="max-height: 220px; overflow-y: auto; min-width: 230px;">
	      <template v-for="(it, i) in moveTargets" :key="it.kind === 'header' ? `h${i}` : it.p.id">
	        <div v-if="it.kind === 'header'"
	             style="font-size: 10px; color: #aaa; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; margin: 8px 0 2px;">
	          {{ it.text }}
	        </div>
	        <div v-else
	          :style="{
	            display: 'flex', alignItems: 'center', gap: '8px', padding: '5px 0',
	            paddingLeft: it.p.parent_id && !it.belassen ? '16px' : '0',
	            cursor: it.belassen || compatibleProjectIds.has(it.p.id) ? 'pointer' : 'not-allowed',
	            opacity: it.belassen || compatibleProjectIds.has(it.p.id) ? '1' : '0.35'
	          }"
	          @click="(it.belassen || compatibleProjectIds.has(it.p.id)) && (selectedPopupProjectId = it.p.id)"
	        >
	          <input type="radio" :checked="selectedPopupProjectId === it.p.id"
	            :disabled="!it.belassen && !compatibleProjectIds.has(it.p.id)"
	            style="cursor:inherit;" />
	          <span :style="{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: it.p.color, flexShrink: 0, display: 'inline-block' }"></span>
	          <span style="font-size: 13px;">{{ it.p.name }}</span>
	          <!-- Die Art dahinter, damit "Rohbau" nicht wie ein eigenes Projekt aussieht -->
	          <span v-if="it.p.category" style="font-size: 11px; color: #999; white-space: nowrap;">{{ CATEGORIES[it.p.category] }}</span>
	          <span v-if="it.belassen" style="font-size: 11px; color: #999;">(belassen)</span>
	        </div>
	      </template>
	    </div>
	    <div class="spacer"/>
	    <button
	      class="w-full flex items-center space-x-2 text-center timin_text_center px-3 py-2 bg-timin hover:brightness-90 text-black"
	      @click="handleMoveApply()"
	    >
	      <span>Verschieben</span>
	    </button>
	  </div>

	</Callout>
	
	<SubprojectModal :open="subprojectFor !== null" :project="subprojectFor"
	                 @cancel="subprojectFor = null" @created="unterprojektAngelegt" />

	<BookingSelectionPopup ref="selectionPopupRef"
	                      :projects="displayProjects"
						  :users="props.users"
						  :bookings="displayBookings"
						  :xScale="xScaleRef"
						  :days="daysRef"
						  @bookingDone="handleBookingDone"
						  @dateupdate="handleDateUpdate"
						  @close="closeSelection" />
						  
    <ConfirmModal ref="confirmModal" :message="modalMessage" :colsitems="modalColsItems" :items="modalItems" :cancelable="modalCancelable" />
	<ConflictModal ref="conflictModal" />

	<div v-if="printProject" class="print-footer">
        <div class="footer-content">
            <button type="button" class="footer-btn" @click="handleDownloadPdf(printProject)">
                <Printer :size="24" />
                <span>PDF Drucken</span>
            </button>
            <button type="button" class="footer-btn secondary" @click="handleRestorePlanner">
                <ArrowBigLeft :size="24" />
                <span>Zurück</span>
            </button>
        </div>
    </div>
  </div>

  <Transition name="undo-btn">
    <button
      v-if="undoStack.length > 0 || undoGesperrt"
      :disabled="undoGesperrt"
      @click="performUndo"
      class="fixed bottom-6 right-6 z-[9998] w-12 h-12 rounded-full bg-timin text-black flex items-center justify-center shadow-lg transition-transform"
      :class="undoGesperrt ? 'opacity-40 cursor-not-allowed' : 'hover:brightness-90 active:scale-95'"
      :title="undoGesperrt
        ? 'Diese Änderung lässt sich nicht rückgängig machen: dabei wurden bestehende Buchungen gekürzt oder gelöscht.'
        : 'Rückgängig (Strg+Z)'"
    >
      <Undo2 :size="20" />
    </button>
  </Transition>

  <div v-if="isLoading" class="fixed inset-0 z-[10001] flex items-center justify-center bg-black/10 pointer-events-auto">
    <div class="animate-spin rounded-full h-10 w-10 border-4 border-white/40 border-t-timin"></div>
  </div>

  <div v-if="isGenerating" class="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 backdrop-blur-sm">
    <Card class="w-[300px] p-6 text-center">
      <div class="mb-4 font-bold text-sm">PDF wird generiert...</div>
      
      <div class="w-full bg-gray-200 rounded-full h-4 overflow-hidden">
        <div 
          class="bg-timin h-full transition-all duration-300 ease-out"
          :style="{ width: progress + '%' }"
        ></div>
      </div>
      
      <div class="mt-2 text-xs text-muted-foreground">{{ Math.round(progress) }}%</div>
    </Card>
  </div>

</template>

<script setup lang="ts">
import {onMounted, onUnmounted, computed, ref, provide, watch, nextTick } from 'vue';
import {useViewStore} from "@/stores/viewStore"
import * as d3 from 'd3';
import {scrollToDate, daysBetween, getHalfYearRange, getQuarterRange, getMonthRange, nextDay, positionTodayLine, cleanx, stopAutoScroll, handleAutoScroll, getWeekBounds, generateTiledPdf, CATEGORIES, sortProjects, removeSelections, computeResourceFilter, sendRequest, prepProject, prepBooking, projectPeriods, dayMs, getWidthPerDay, getRowHeight, box2int, setDim, getProjectFromRow, xToIso, formatDateDDMMYYYY, validateProjectDuration, validateParentDuration, findNearestConflict, clipRangeAgainstConflict, normalizePeriods, MIN_PAUSE_DAYS} from "./planner.js";
import {fromIso, toGerman, fromGerman, addDays, toIsoLocal, daysBetween as daysBetweenIso} from '@/utils/dateUtils';
import BookingSelectionPopup from './BookingSelectionPopup.vue'
import SubprojectModal from './SubprojectModal.vue'
import Corner from './Corner.vue'
import Timeaxis from './Timeaxis.vue'
import ProjectHeader from './ProjectHeader.vue'
import ProjectTimesheet from './ProjectTimesheet.vue'
import HighlightDays from './HighlightDays.vue'
import ConfirmModal from './ConfirmModal.vue'
import ConflictModal from './ConflictModal.vue'
import DateInput from "./DateInput.vue"
import Callout from './Callout.vue'
import { Card } from "@/components/ui/card"
import { Printer, ArrowBigLeft, Undo2 } from "lucide-vue-next"
import { colscollisions } from '../timintables/colscollisions'
import { POPUP_BUS } from './popupBus'

const props = defineProps({
  projects: { type: Array, required: true },
  bookings: { type: Array, required: true },
  users: { type: Array, required: true },
  configs: { type: Array, required: true },
});

const cornerRef = ref(null);
const sidebarRef = ref(null);
const timesheetRef = ref(null)

const isGenerating = ref(false);
const progress = ref(0); // 0 to 100

const handleDownloadPdf = async (project) => {
  if (!timesheetRef.value) return;
  
  isGenerating.value = true;
  progress.value = 0; // Reset progress
  
  try {
    const { default: html2canvas } = await import('html2canvas');
    const { jsPDF } = await import('jspdf');

    // Pass a callback to update progress
    await generateTiledPdf(project,
      timesheetRef.value,
      cornerRef.value,
      sidebarRef.value,
      html2canvas,
      jsPDF,
      view.zoomWidthPerDay,
      startDate.value,
      endDate.value,
      (p) => { progress.value = p; }
    );
    
  } catch (error) {
    console.error("PDF Generation failed:", error);
  } finally {
    // Small delay so the user sees "100%" before it vanishes
    setTimeout(() => {
      isGenerating.value = false;
      progress.value = 0;
    }, 500);
  }
};

const view = useViewStore();
view.setCountActiveUsers(props.users.filter(u => u.role_id > 0 && u.is_active === 1).length)

const selectionPopupRef = ref(null)
const confirmModal = ref(null)
const conflictModal = ref(null)
const modalColsItems = ref(null)
const modalItems = ref([])
const modalMessage = ref("Bestätigen")
// Nur bei echten Rueckfragen bekommt der Dialog einen Abbrechen-Knopf.
const modalCancelable = ref(false)
const projectFilter = ref({all: view.showAllBookings(), active: view.showActiveProjects(), planned: view.showPlannedProjects()})
const xScaleRef = ref(null);
const daysRef = ref([]);

const isLoading = ref(false)

const printProject = ref<any>(null)
const printStart = ref(null)
const printEnd = ref(null)

const startDateStr = props.configs.find(c => c.name === "startdate").value;
const endDateStr = props.configs.find(c => c.name === "enddate").value;

// Achsen-Grenzen liegen auf UTC-Mitternacht, passend zu scaleUtc und zu
// fromIso/toIso im Modell (TIM-36).
const initialStartDate = fromIso(startDateStr);
const initialEndDate   = fromIso(endDateStr);

const activeZoomVal = ref(0)
const activeZoomStart = ref(initialStartDate)
const activeZoomEnd = ref(initialEndDate)

const startDate = ref<Date>(initialStartDate)
const endDate   = ref<Date>(initialEndDate)

let widthPerDay = getWidthPerDay(printProject.value !== null, view.zoomWidthPerDay)
// Auf UTC-Mitternacht sind die Abstaende exakt 24 h; Math.round haelt das
// Ergebnis auch dann ganzzahlig, wenn eine Grenze doch einmal anders entsteht.
const totalDays = Math.round((endDate.value.getTime() - startDate.value.getTime()) / dayMs);

const x = d3.scaleUtc().domain([startDate.value, endDate.value]).range([0, totalDays * widthPerDay]);

xScaleRef.value = x;

const dayWidth = cleanx(x, new Date(2024, 0, 2)) - cleanx(x, new Date(2024, 0, 1));

watch(
  [printStart, printEnd],
  async ([ps, pe]) => {
	console.log("watch printStart, printEnd=" + ps + " " + pe)
    if (ps && pe) {
      // If ps is already a Date object, don't append the time string
      // Achsen-Grenzen auf UTC-Mitternacht (Raster von d3.utcDay).
      startDate.value = ps instanceof Date ? ps : fromIso(fromGerman(ps));
      endDate.value   = pe instanceof Date ? pe : fromIso(fromGerman(pe));
    } else {
      startDate.value = initialStartDate;
      endDate.value   = initialEndDate;
    }
	  console.log("watch new values=" + startDate.value + " " + endDate.value)

    await nextTick();
    renderTimesheet();
  }
);


async function doZoom(zoomValue, sdate, edate) {
  const container = document.getElementById("planner-container")
  const sidebar = document.getElementById("sidebar")

  if (container) {
    let newDayWidth = null;
    view.setZoomVal(zoomValue);
    if (zoomValue > 0) {
      const widthA = container.getBoundingClientRect().width
      const widthB = sidebar.getBoundingClientRect().width
      const remainingWidth = Math.floor(widthA - widthB);
      let divider = 7;
      if (zoomValue === 1) {
      } else if (zoomValue === 2) {
        const { startOfMonth, endOfMonth } = getMonthRange(new Date())
        divider = daysBetween(startOfMonth, endOfMonth);
      } else if (zoomValue === 3) {
        const { startOfQuarter, endOfQuarter } = getQuarterRange(new Date())
        divider = daysBetween(startOfQuarter, endOfQuarter);
      } else if (zoomValue === 4) {
        const { startOfHalf, endOfHalf } = getHalfYearRange(new Date())
        divider = daysBetween(startOfHalf, endOfHalf);
      } else if (zoomValue === 5) {
        view.setZoomStart(sdate)
        view.setZoomEnd(edate)
        divider = daysBetween(sdate, edate, false);
      }
      newDayWidth = Math.floor(remainingWidth / divider);
    }
    view.setZoomWidthPerDay(newDayWidth)
  }

  await nextTick()
  renderTimesheet()
};

watch(activeZoomVal, async (newValue, oldValue) => {
  doZoom(newValue, activeZoomStart.value, activeZoomEnd.value)
});

const entityStartDate = ref(formatDateDDMMYYYY(new Date()));
const entityEndDate = ref(formatDateDDMMYYYY(new Date()));

const uid = ref(document.getElementById('app').dataset.uid)
console.log("uid=" + uid.value)
const localProjects = ref<any[]>([...props.projects]);
// Zeilen des Planers: Projekte, ihre Unterprojekte und die Kategorie-
// Ueberschriften dazwischen (TIM-73). Eine Ueberschrift ist kein Projekt -
// Stellen, die ueber echte Projekte laufen, filtern sie wie isspacer heraus.
const displayProjects = computed(() => [
  ...sortProjects(localProjects.value.filter(p => projectFilter.value.active  && p.status === 0 && (printProject.value ? printProject.value.id === p.id : true))).map(p => prepProject(p)),
  ...sortProjects(localProjects.value.filter(p => projectFilter.value.planned && p.status === 2)).map(p => prepProject(p)),
]
  // Ein zugeklapptes Projekt nimmt seine Bereiche mit, und ausgeblendete
  // Kategorien verschwinden ganz - welche sichtbar sind, steuert der
  // Filterdialog.
  .filter(p => {
    if (!p.parent_id) return true
    if (!view.isOpenProject(p.parent_id)) return false
    const sichtbare = resourceFilter.value[p.parent_id]?.filter?.categories
    return !sichtbare || sichtbare.includes(p.category)
  })
);

// Letzte Zeilengruppe eines Projektblocks? Der Farbbalken setzt genau dort aus,
// nicht am Anfang des naechsten - so gehoert der Abstand sichtbar zu dem
// Projekt, das endet, und zwar auf der Stufe, auf der es gerade endet.
// Ein Block ist ein Hauptprojekt mit seinen Bereichen; die Wurzel entscheidet.
function istBlockEnde(i: number) {
  const rows = displayProjects.value
  const naechst: any = rows[i + 1]
  if (!naechst) return true
  const wurzel = (p: any) => p.parent_id ?? p.id
  return wurzel(rows[i]) !== wurzel(naechst)
}

// Wo der Block der aktiven Projekte endet und der der potentiellen beginnt.
// displayProjects haengt die beiden Gruppen hintereinander; getrennt wird also
// genau an der ersten Zeile mit Status 2, die eine mit anderem Status ueber
// sich hat. Steht kein aktives Projekt darueber - etwa weil der Filter nur die
// potentiellen zeigt -, gibt es nichts zu trennen.
function istGruppenwechsel(i: number) {
  if (i === 0) return false
  const rows = displayProjects.value
  return rows[i]?.status === 2 && rows[i - 1]?.status !== 2
}

// Wie viele Zeilen unter einem Hauptprojekt stehen: die Kategorie-
// Ueberschriften, die Unterprojekte selbst und deren Personenzeilen, sofern
// aufgeklappt. Der 1-px-Rahmen des Projekts braucht das, weil er sie
// mitumfassen soll - und nur hier ist bekannt, was tatsaechlich gerendert wird.
const subRowCounts = computed<Record<string, number>>(() => {
  const rows = displayProjects.value
  const zeilen: Record<string, number> = {}

  for (let i = 0; i < rows.length; i++) {
    const p: any = rows[i]
    if (p.parent_id) continue

    let n = 0
    for (let j = i + 1; j < rows.length; j++) {
      const r: any = rows[j]
      if (r.parent_id !== p.id) break          // naechstes Hauptprojekt erreicht
      n += 1
      if (view.isOpenProject(r.id)) {
        n += resourceFilter.value[r.id]?.visible?.size ?? 0
      }
    }
    zeilen[p.id] = n
  }
  return zeilen
})

const localBookings = ref<any[]>([...props.bookings]);

const undoStack = ref<any[]>([])
// Wahr, wenn die letzte Aktion bestehende Buchungen gekuerzt oder geloescht
// hat. Dann wird der Knopf ausgegraut statt zu verschwinden, damit sichtbar
// bleibt, dass es ihn gibt und warum er gerade nicht geht (TIM-53).
const undoGesperrt = ref(false)
let isUndoing = false

// Ein Fingerabdruck einer Buchung, um hinterher zu erkennen, ob eine
// bestehende gekuerzt, verschoben oder geloescht wurde (TIM-53). Nur die
// ersten zehn Zeichen des Datums, damit ein Zeitanteil nicht stoert.
function bookingSignatur(b: any) {
  return `${b.project_id}|${String(b.start).slice(0, 10)}|${String(b.end).slice(0, 10)}`
}

function pushUndo(action: any) {
  if (isUndoing) return
  undoStack.value.push(action)
  if (undoStack.value.length > 20) undoStack.value.shift()
}
// props.users enthaelt nur aktive Personen. Buchungen aller anderen muessen hier
// raus: sie bekaemen keine Zeile, wuerden vom Tageszaehler aber mitgezaehlt - die
// Zahl stand dann ueber Balken, die es nicht gibt (TIM-30).
// Der Filter sitzt bewusst hier und nicht beim Laden: nach jeder Buchungsaenderung
// ersetzt handleBookingDone localBookings durch die Antwort von /update_bookings,
// und die liefert unveraendert alle Buchungen.
const activeUserIds = computed(() => new Set(props.users.map((u: any) => u.id)));

const displayBookings = computed(() =>
  localBookings.value
    .filter(b => activeUserIds.value.has(b.user_id))
    .filter(b => projectFilter.value.all || b.user_id.toString() === uid.value.toString())
    .map(b => prepBooking(b))
);

// Bewusst ein computed und kein ref: die Filter sind Regeln, die nach jeder
// Buchungsaenderung neu ausgewertet werden muessen. Als eingefrorene Liste
// fehlte einer frisch gebuchten Person ihre Zeile (TIM-17).
const resourceFilter = computed(() =>
  computeResourceFilter(view, localProjects.value, props.users, localBookings.value)
);


const emit = defineEmits(['update:bookings', 'update:projects', 'reload'])

let leftLastTop = 0;
let leftLastLeft = 0;

let rightLastTop = 0;
let rightLastLeft = 0;


// Guard gegen das Echo der Zwei-Wege-Synchronisation: Setzen wir programmatisch
// other.scrollTop, feuert dort ein scroll-Event, das sonst el.scrollTop zurücksetzt.
// Auf iOS bricht so eine Rückzuweisung das laufende Touch-Scrollen ab ("klebt").
let suppressSync = false;

function syncScroll(source) {
  if (suppressSync) { suppressSync = false; return; }

  const el = source === 'left' ? sidebarRef.value : timesheetRef.value;
  const other = source === 'left' ? timesheetRef.value : sidebarRef.value;
  if (!el || !other) return;

  if (other.scrollTop !== el.scrollTop) {
    suppressSync = true;           // das folgende scroll-Event auf `other` ignorieren
    other.scrollTop = el.scrollTop;
  }
}

function handleSetProjectFilter(all, active, planned) {
  view.setProjectFilter(all, active, planned); 
}

function handleZoom(newZoomLevel, startdate, enddate) {
  console.log("newZoomLevel=" + newZoomLevel + " startdate=" + startdate + " enddate=" + enddate);
  activeZoomVal.value = newZoomLevel
  activeZoomStart.value = fromIso(fromGerman(startdate))
  activeZoomEnd.value = fromIso(fromGerman(enddate))
  doZoom(activeZoomVal.value, activeZoomStart.value, activeZoomEnd.value)
}

// Unterprojekt anlegen (TIM-73). Das Menue am Projektkopf oeffnet den Dialog,
// nach dem Anlegen wandert das neue Projekt in die lokale Liste - ein Neuladen
// der Seite waere fuer eine Zeile zu viel.
const subprojectFor = ref<any>(null)

function oeffneUnterprojektDialog(project: any) {
  subprojectFor.value = project
}

function unterprojektAngelegt(neu: any) {
  const eltern = subprojectFor.value
  subprojectFor.value = null
  if (!neu?.id) return

  localProjects.value = [...localProjects.value, neu]
  // Damit es sofort sichtbar ist: das Hauptprojekt aufklappen, falls es zu war.
  if (eltern && !view.isOpenProject(eltern.id)) view.toggleProject(eltern.id)
}

function updateProjectOpenstates(pid) {
	view.toggleProject(pid);
}

function handleUpdateResourceFilter(pid, filter) {
  // Nur in den Store schreiben — resourceFilter zieht als computed nach.
  view.setResourceFilter(pid, filter)
}


const showPopup = ref(false)
const popupTarget = ref<HTMLElement | null>(null)
const popupType = ref(null);
const popupMode = ref<string | null>(null);
const popupEntity = ref(null);
// Zeitabschnitte im Dialog, als deutsche Datumszeichenketten fuer DateInput.
const periodRows = ref<{ start: string, end: string }[]>([]);
const selectedPopupProjectId = ref<number | null>(null);

function openPopupAt(el: HTMLElement, entity) {
  console.log("openPopupAt id=" + el.id + "=" + JSON.stringify(entity))
  popupTarget.value = el
  showPopup.value = true
  const eintrag = entity.isproject
    ? localProjects.value.find((p: any) => p.id === entity.id)
    : null;

  // Der Balken eines Bereichs klappt ihn auf und zu - mehr hat er nicht zu tun,
  // seit sein Zeitraum vom Hauptprojekt kommt (TIM-73). Ein Dialog waere leer,
  // und gar keine Reaktion liest sich wie ein Fehler. Dieselbe Wirkung wie der
  // Pfeil in der Seitenleiste, nur mit einer viel groesseren Flaeche.
  if (eintrag?.parent_id) {
    view.toggleProject(entity.id);
    showPopup.value = false;
    return;
  }

  popupType.value = entity.isproject ? 0 : 1;
  popupMode.value = entity.isproject ? 'datechange' : 'context';
  entityStartDate.value = toGerman(entity.start);
  entityEndDate.value = toGerman(entity.end);
  popupEntity.value = entity;
  if (entity.isproject) {
    const project = eintrag
    const periods = projectPeriods(project ?? { start: entity.start, end: entity.end })
    periodRows.value = periods.map((pd: any) => ({ start: toGerman(pd.start), end: toGerman(pd.end) }))
  }
  if (!entity.isproject) {
    const booking = localBookings.value.find((b: any) => b.id === entity.id)
    selectedPopupProjectId.value = booking ? booking.project_id : null
  }
}

function closePopup() {
  showPopup.value = false
  closeSelection();		
}

// Zentrale Konfliktauflösung: prüft Fremdbuchungen derselben Person im Zielzeitraum,
// zeigt bei Bedarf den 3-Optionen-Dialog und liefert die anzuwendende Spanne zurück.
// Rückgabe: [startIso, endIso] (anwenden) oder null (abbrechen).
async function resolveConflict({ userId, excludeId, startIso, endIso, origStartIso, origEndIso, projectId }) {
  // localProjects statt displayProjects: die Regel muss auch greifen, wenn die
  // Gegenseite gerade weggefiltert oder zugeklappt ist.
  const conflict = findNearestConflict(localBookings.value, userId, excludeId, startIso, endIso, origStartIso, origEndIso,
                                       localProjects.value, projectId)
  if (!conflict) return [startIso, endIso]
  if (conflict.isVacation) {
    alert('Umbuchungen von/über Urlaubsbuchungen nicht möglich. Bitte zuerst frei machen.')
    return null
  }
  const proj = displayProjects.value.find((p: any) => p.id === conflict.booking.project_id)
  const user = props.users.find((u: any) => u.id === userId)
  const clipped = clipRangeAgainstConflict(startIso, endIso, conflict.booking, conflict.side)
  const choice = await conflictModal.value.open({
    userName: user ? `${user.firstname} ${user.lastname}` : `Person ${userId}`,
    projectName: proj ? proj.name : `Projekt ${conflict.booking.project_id}`,
    projectColor: proj ? proj.color : null,
    startLabel: toGerman(conflict.booking.start, '.'),
    endLabel: toGerman(conflict.booking.end, '.'),
    partialAvailable: clipped != null,
  })
  if (choice === 'cancel') return null
  if (choice === 'partial') return clipped
  return [startIso, endIso]  // overwrite: volle Spanne, Backend schneidet die Fremdbuchung zurecht
}

// Provide the API for children
// Ein Leistungsbereich wird ins Hauptprojekt gespiegelt - der Spiegel muss also
// in einen Abschnitt passen. Faellt die Buchung in eine Pause, wird gefragt, ob
// die Laufzeit des Hauptprojekts angepasst werden soll; erst danach geht die
// Buchung durch. Fuer alle anderen Kategorien passiert hier nichts.
//
// Rueckgabe: true = weitermachen, false = abbrechen.
async function ensureParentCovers(project: any, bstart: string, bend: string) {
  const [ok, aendern, newpstart, newpend, , haupt] =
    validateParentDuration(project, localProjects.value, bstart, bend)

  if (!ok) return false          // Nutzer hat die Frage verneint
  if (!aendern || !haupt) return true

  isLoading.value = true
  const erfolg = await new Promise<boolean>((resolve) => {
    sendRequest('/change_project_date', {
      // id, nicht nur selected_pid: die Action haengt an set_project, und das
      // sucht ueber params[:id]. Ohne den Parameter antwortet der Server mit 404.
      id: haupt.id,
      selected_pid: haupt.id,
      firstDay: newpstart,
      lastDay: newpend,
      changedir: false,
      shift: false,
    }, (response: any) => {
      if (response['projects']) localProjects.value = response['projects']
      resolve(true)
    }, (response: any) => {
      alert(response?.error ?? 'Die Laufzeit des Hauptprojekts konnte nicht angepasst werden.')
      resolve(false)
    })
  })
  isLoading.value = false
  return erfolg
}

provide(POPUP_BUS, { openPopupAt, closePopup, resolveConflict, ensureParentCovers })

// Anfang und Ende koennen sich nicht mehr ueberkreuzen: schiebt man den Anfang
// hinter das Ende, wandert das Ende mit, und umgekehrt. Vorher liess sich so
// eine Buchung mit Ende vor Anfang bauen - der Server brach dann ab, und die
// Meldung kam als "undefined" beim Nutzer an. Siehe TIM-54.
function handleStartDateChange(d) {
  entityStartDate.value = d;
  if (fromGerman(d) > fromGerman(entityEndDate.value)) entityEndDate.value = d;
}

function handleEndDateChange(d) {
  entityEndDate.value = d;
  if (fromGerman(d) < fromGerman(entityStartDate.value)) entityStartDate.value = d;
}

// Die Buchung, um die es im Verschieben-Popup gerade geht.
const movingBooking = computed(() =>
  (!popupEntity.value || popupEntity.value.isproject)
    ? null
    : localBookings.value.find((b: any) => b.id === popupEntity.value.id) ?? null
)

const currentMovePid = computed(() => movingBooking.value ? movingBooking.value.project_id : null)

// Moegliche Ziele. Bewusst aus localProjects und nicht aus displayProjects:
// dort fehlen die Bereiche zugeklappter Projekte und die einer ausgeblendeten
// Kategorie - man koennte also nicht dorthin verschieben, bloss weil die Zeile
// gerade nicht zu sehen ist. Der Status-Filter bleibt: ein ausgefiltertes
// Projekt ist kein sinnvolles Ziel.
const moveCandidates = computed(() => {
  if (!movingBooking.value) return []
  const waehlbar = localProjects.value.filter((p: any) =>
    p.id !== 0 &&
    ((projectFilter.value.active && p.status === 0) || (projectFilter.value.planned && p.status === 2)))
  const sortiert = sortProjects(waehlbar).map((p: any) => prepProject(p))
  // sortProjects haengt jedes Unterprojekt an sein Hauptprojekt. Ist dieses
  // gerade ausgefiltert, faellt der Bereich hinten runter - als Ziel soll er
  // trotzdem erreichbar bleiben.
  const drin = new Set(sortiert.map((p: any) => p.id))
  const uebrig = waehlbar.filter((p: any) => !drin.has(p.id)).map((p: any) => prepProject(p))
  return [...sortiert, ...uebrig]
})

// Dieselbe Liste als Zeilen, mit Zwischenueberschriften. Der Baum, in dem die
// Buchung schon steckt, steht oben: von dort kommen die haeufigsten Ziele, und
// ein Bereich heisst oft nur "Rohbau" - erst unter seinem Hauptprojekt ist
// klar, welcher gemeint ist.
const moveTargets = computed(() => {
  const alle = moveCandidates.value
  if (alle.length === 0) return []

  const current = alle.find((p: any) => p.id === currentMovePid.value) ?? null
  const wurzel = current ? (current.parent_id ?? current.id) : null
  const imBaum = (p: any) => wurzel !== null && (p.parent_id ?? p.id) === wurzel

  const items: any[] = []
  if (current) items.push({ kind: 'project', p: current, belassen: true })

  const rest = alle.filter((p: any) => p.id !== currentMovePid.value)
  const nah = rest.filter(imBaum)
  const fern = rest.filter((p: any) => !imBaum(p))

  if (nah.length) {
    items.push({ kind: 'header', text: 'Im selben Projekt' })
    for (const p of nah) items.push({ kind: 'project', p })
  }
  if (fern.length) {
    if (nah.length || current) items.push({ kind: 'header', text: 'Andere Projekte' })
    for (const p of fern) items.push({ kind: 'project', p })
  }
  return items
})

const compatibleProjectIds = computed(() => {
  if (!entityStartDate.value || !entityEndDate.value) return new Set<number>()
  const bStart = fromGerman(entityStartDate.value)
  const bEnd = fromGerman(entityEndDate.value)
  if (!bStart || !bEnd) return new Set<number>()
  return new Set<number>(
    moveCandidates.value
      .filter((p: any) => bStart <= p.end && bEnd >= p.start)
      .map((p: any) => p.id)
  )
})

watch(compatibleProjectIds, (compatible) => {
  if (selectedPopupProjectId.value !== null && !compatible.has(selectedPopupProjectId.value)) {
    selectedPopupProjectId.value = currentMovePid.value
  }
})

function shiftDate(dateStr: string, days: number): string {
  const iso = fromGerman(dateStr)
  if (!iso) return dateStr
  return toGerman(addDays(iso, days))
}

// Laenge der Pause, die beim Teilen entsteht, in FREIEN Tagen: acht, also einer
// mehr als die Grenze, ab der zwei Abschnitte beim Speichern wieder verschmelzen
// (MIN_PAUSE_DAYS, siehe TIM-66).
const SPLIT_PAUSE_DAYS = MIN_PAUSE_DAYS + 1

// Der Tag, der gerade mittig im Planer steht. Der Planer scrollt waagerecht -
// der Zeitraum der Achse ist also nicht das, was man tatsaechlich sieht.
function visibleCenterIso() {
  const el = document.getElementById('main-scroll-area')
  const scale = xScaleRef.value
  if (!el || !scale) return null
  return xToIso(scale, el.scrollLeft + el.clientWidth / 2)
}

// Den sichtbaren Abschnitt am mittigen Tag in zwei teilen (TIM-67). Gibt false
// zurueck, wenn das nicht geht - dann faellt addPeriodRow auf das Anhaengen
// zurueck. Zwei Gruende dafuer: der mittige Tag liegt in keinem Abschnitt, oder
// der Abschnitt ist zu kurz, um links und rechts der Pause noch je einen Tag
// uebrig zu lassen.
function splitVisiblePeriod() {
  const mitte = visibleCenterIso()
  if (!mitte) return false

  const i = periodRows.value.findIndex((r: any) => {
    const s = fromGerman(r.start), e = fromGerman(r.end)
    return s && e && s <= mitte && mitte <= e
  })
  if (i < 0) return false

  const row = periodRows.value[i]
  const ersterEnd    = addDays(mitte, -1)
  const zweiterStart = addDays(mitte, SPLIT_PAUSE_DAYS)
  if (ersterEnd < fromGerman(row.start) || zweiterStart > fromGerman(row.end)) return false

  periodRows.value.splice(i, 1,
    { start: row.start, end: toGerman(ersterEnd) },
    { start: toGerman(zweiterStart), end: row.end },
  )
  return true
}

// "+ Abschnitt" teilt den sichtbaren Abschnitt, statt hinten einen neuen
// anzuhaengen: wer hier klickt, will fast immer eine Pause INNERHALB der
// Laufzeit, keine Verlaengerung des Projekts. Klappt das Teilen nicht, bleibt
// es beim alten Verhalten - neuer Abschnitt hinter dem letzten, mit genug
// Abstand, damit er beim Speichern nicht sofort wieder verschmilzt.
function addPeriodRow() {
  if (splitVisiblePeriod()) return

  const last = periodRows.value[periodRows.value.length - 1]
  // Die Acht ist hier ein ABSTAND (naechster Anfang minus voriges Ende), nicht
  // die Zahl freier Tage - unveraendert wie vor TIM-67.
  const from = last ? addDays(fromGerman(last.end), 8) : toIsoLocal(new Date())
  periodRows.value.push({ start: toGerman(from), end: toGerman(addDays(from, 6)) })
}

// Der Server fasst beim Speichern Abschnitte zusammen, deren Pause kuerzer als
// MIN_PAUSE_DAYS ist (ProjectPeriod.normalize). Ohne Rueckmeldung sieht das aus,
// als haette das Aufteilen nicht funktioniert - der Balken ist hinterher wieder
// einer. Liefert den Hinweistext oder null, wenn alle Pausen lang genug sind.
//
// Zwei Fallstricke stecken in der Rechnung: die Pause ist
// (naechster.start - voriger.end - 1) Tage lang, und gerechnet wird mit der
// ISO-Variante von daysBetween - die gleichnamige Funktion aus planner.js nimmt
// den Absolutbetrag und liefert mindestens 7.
function shortPauseHint(periods) {
  const bleibt = normalizePeriods(periods)
  if (bleibt.length >= periods.length) return null

  const sortiert = [...periods].sort((a: any, b: any) => a.start.localeCompare(b.start))
  const kurze = []
  for (let i = 1; i < sortiert.length; i++) {
    const tage = daysBetweenIso(sortiert[i - 1].end, sortiert[i].start) - 1
    if (tage < MIN_PAUSE_DAYS) kurze.push(tage)
  }

  const kleinste = Math.min(...kurze)
  let stelle
  if (kurze.length > 1) {
    stelle = `An ${kurze.length} Stellen ist die Pause zu kurz`
  } else if (kleinste <= 0) {
    stelle = 'Die beiden Abschnitte grenzen aneinander'
  } else {
    stelle = kleinste === 1
      ? 'Zwischen zwei Abschnitten liegt nur 1 Tag Pause'
      : `Zwischen zwei Abschnitten liegen nur ${kleinste} Tage Pause`
  }

  const ergebnis = bleibt.length === 1
    ? `es bleibt ein Abschnitt vom ${toGerman(bleibt[0].start)} bis ${toGerman(bleibt[0].end)}`
    : `aus ${periods.length} Abschnitten werden ${bleibt.length}`

  return `${stelle}. Pausen unter ${MIN_PAUSE_DAYS} Tagen werden zusammengefasst — ${ergebnis}.`
}

// Abschnitte speichern. Zuerst fragt der Server im Vorschaumodus, was mit den
// Buchungen geschehen WUERDE - faellt dabei etwas an, wird zurueckgefragt,
// bevor wirklich geaendert wird.
function handlePeriodsApply() {
  const entity = popupEntity.value
  const periods = periodRows.value
    .map((r: any) => ({ start: fromGerman(r.start), end: fromGerman(r.end) }))
    .filter((r: any) => r.start && r.end)

  if (periods.length === 0) {
    alert('Es muss mindestens ein Zeitabschnitt bleiben.')
    return
  }
  if (periods.some((r: any) => r.end < r.start)) {
    alert('Ein Abschnitt endet vor seinem Anfang.')
    return
  }

  // Der Hinweis wird vor dem Absenden gerechnet, aus den eingegebenen Zeilen -
  // die Antwort des Servers enthaelt nur noch die zusammengefassten Abschnitte.
  const pauseHinweis = shortPauseHint(periods)

  closePopup()
  isLoading.value = true
  sendRequest('/update_project_periods', { id: entity.id, periods, preview: true }, async function(vorschau) {
    isLoading.value = false
    const c = vorschau['changed_bookings'] || {}
    const teile = []
    if (c.trimmed) teile.push(`${c.trimmed} gekürzt`)
    if (c.deleted) teile.push(`${c.deleted} entfernt`)
    if (c.split)   teile.push(`${c.split} in zwei einzelne geteilt`)

    // Beides landet in einer Meldung: zwei Dialoge hintereinander fuer denselben
    // Klick sind laestig, und der Nutzer soll einmal entscheiden.
    const meldungen = []
    if (pauseHinweis) meldungen.push(pauseHinweis)
    if (teile.length > 0) {
      // Die betroffenen Bereiche beim Namen nennen (TIM-73): eine Pause im
      // Projekt schneidet auch die Buchungen seiner Leistungsbereiche, und ohne
      // den Hinweis wuesste niemand, wo die Aenderungen anfallen.
      const bereiche = vorschau['changed_bookings']?.bereiche ?? []
      const wo = bereiche.length ? ` – auch in ${bereiche.join(', ')}` : ''
      meldungen.push(`Änderungen bei Buchungen: ${teile.join(', ')}${wo}`)
    }

    if (meldungen.length > 0) {
      modalMessage.value = meldungen.join('\n\n')
      modalColsItems.value = []
      modalItems.value = []
      modalCancelable.value = true
      const ok = await confirmModal.value.open()
      modalCancelable.value = false
      if (!ok) {
        updatePlanner()
        return
      }
    }
    savePeriods(entity, periods)
  }, function(response) {
    isLoading.value = false
    alert(response['error'])
    updatePlanner()
  })
}

// Die Abschnitte wirklich schreiben.
function savePeriods(entity, periods) {
  isLoading.value = true
  sendRequest('/update_project_periods', { id: entity.id, periods }, function(response) {
    isLoading.value = false
    const project = localProjects.value.find((p: any) => p.id === entity.id)
    if (project) {
      project.periods = response['periods']
      project.start = response['start']
      project.end = response['end']
    }
    // Ohne das zeigten die Balken weiter die alten Zeitraeume: der Server hat
    // die Buchungen an die Pausen angepasst, das Frontend wusste nichts davon.
    if (response['bookings']) localBookings.value = response['bookings']
    updatePlanner()
  }, function(response) {
    isLoading.value = false
    alert(response['error'])
    updatePlanner()
  })
}

async function handleDateChangeApply() {
  const entity = popupEntity.value;
  const isProject = entity.isproject;
  const pid = isProject ? entity.id : selectedPopupProjectId.value;

  // Projektzeitraum ändern: unverändertes Verhalten (keine Personen-Konflikte relevant).
  // firstDay/lastDay gehen als ISO raus – wie schon auf dem Undo-Pfad (projectChangeDone).
  if (isProject) {
    closePopup();
    projectChangeDone({
      isproject: true, id: entity.id, booking_action: pid, selected_pid: pid, selected_bid: null,
      firstDay: fromGerman(entityStartDate.value), lastDay: fromGerman(entityEndDate.value), newpstart: null, newpend: null,
      selectedResources: [entity.uid], shift: false, changedir: false,
    });
    return;
  }

  // Buchungszeitraum ändern: ISO-Spanne, Konfliktprüfung, dann Projektzeitraum-Prüfung.
  let startIso = fromGerman(entityStartDate.value);
  let endIso = fromGerman(entityEndDate.value);
  const booking = localBookings.value.find((b: any) => b.id === entity.id);
  closePopup();

  const resolved = await resolveConflict({
    userId: entity.uid, excludeId: entity.id, startIso, endIso,
    origStartIso: booking ? booking.start : null, origEndIso: booking ? booking.end : null,
    projectId: pid,
  });
  if (!resolved) return;
  [startIso, endIso] = resolved;

  const project = displayProjects.value.find((p: any) => p.id === pid);
  const [validate, extend, ps, pe] = validateProjectDuration(project, startIso, endIso);
  if (!validate) return;
  if (!(await ensureParentCovers(project, startIso, endIso))) return;

  handleBookingDone({
    isproject: false, id: entity.id, booking_action: pid, selected_pid: pid, selected_bid: entity.id,
    firstDay: startIso, lastDay: endIso, newpstart: extend ? ps : null, newpend: extend ? pe : null,
    selectedResources: [entity.uid], shift: false, changedir: false,
  }, null);
}

async function handleMoveApply() {
  const booking = localBookings.value.find((b: any) => b.id === popupEntity.value.id);
  const targetProjectId = (selectedPopupProjectId.value !== null && selectedPopupProjectId.value !== booking?.project_id)
    ? selectedPopupProjectId.value
    : null;
  // Vor closePopup nachschlagen: moveCandidates haengt am Popup und ist danach
  // leer. Und nicht aus displayProjects - das Ziel kann ein Bereich sein, dessen
  // Zeile gerade zugeklappt ist.
  const project = moveCandidates.value.find((p: any) => p.id === targetProjectId) ?? null;
  closePopup();
  if (targetProjectId === null || !booking || !project) return;

  const oldProjectId = booking.project_id;
  const userId = booking.user_id;

  const resolved = await resolveConflict({
    userId, excludeId: booking.id, startIso: booking.start, endIso: booking.end,
    origStartIso: booking.start, origEndIso: booking.end,
    // Gegen das ZIEL pruefen: ob die Buchung dort kollidiert, entscheidet der
    // Bereich, in den sie soll - nicht der, aus dem sie kommt.
    projectId: targetProjectId,
  });
  if (!resolved) return;
  const [startIso, endIso] = resolved;

  const [validate, extend, newpstart, newpend] = validateProjectDuration(project, startIso, endIso);
  if (!validate) return;
  if (!(await ensureParentCovers(project, startIso, endIso))) return;

  handleBookingDone({
    booking_action: targetProjectId,
    selected_pid: targetProjectId,
    selected_bid: booking.id,
    firstDay: startIso,
    lastDay: endIso,
    newpstart: extend ? newpstart : null,
    newpend: extend ? newpend : null,
    selectedResources: [userId],
  }, function() {
    // Frueher wurde die Sichtbarkeitsliste beider Projekte hier von Hand
    // nachgezogen. Das entfaellt: resourceFilter wertet die Regel bei jeder
    // Buchungsaenderung ohnehin neu aus.
    updatePlanner();
  });
}

function handleDeleteFromContext() {
  if (!popupEntity.value) return;
  const bookingId = popupEntity.value.id;
  const booking = localBookings.value.find((b: any) => b.id === bookingId);
  if (!booking) return;
  pushUndo({ type: 'deletedBooking', booking: { ...booking } });
  localBookings.value = localBookings.value.filter((b: any) => b.id !== bookingId);
  isLoading.value = true;
  closePopup();
  sendRequest(`/bookings/${bookingId}`, {}, function() {
    isLoading.value = false;
    updatePlanner();
  }, function(response) {
    undoStack.value.pop();
    localBookings.value.push(booking);
    isLoading.value = false;
    alert(response.error || 'Fehler beim Löschen');
    updatePlanner();
  }, 'DELETE');
}

function updatePlanner() {
	closeSelection();	
	//emit('reload');
}

async function handleBookingDone(params, afterSuccess: (() => void) | null = null) {
  // Ein Leistungsbereich wird ins Hauptprojekt gespiegelt: liegt die Buchung in
  // einer Pause von dessen Laufzeit, wird zuerst gefragt, ob diese angepasst
  // werden soll (TIM-73). Hier, weil durch diese Funktion jede Buchung laeuft -
  // auch die aus dem Auswahl-Popup, das die Pruefung in Task.vue nicht beruehrt.
  const zielProjekt = localProjects.value.find((p: any) => p.id === params.selected_pid)
  if (zielProjekt && params.firstDay && params.lastDay) {
    if (!(await ensureParentCovers(zielProjekt, params.firstDay, params.lastDay))) return
  }

  // Zustand VOR der Aktion. Der Server kuerzt, teilt oder loescht beim Buchen
  // alles, was im gewaehlten Zeitraum liegt (update_booking im Controller).
  // Rueckgaengig kann das niemand, weil der Vorzustand nirgends gesichert wird
  // - der Undo-Zweig loescht nur die neu entstandenen Buchungen und macht die
  // Luecke damit sogar groesser. Deshalb hinterher vergleichen und in so einem
  // Fall gar kein Rueckgaengig anbieten. Siehe TIM-53.
  undoGesperrt.value = false
  // Vollstaendige Kopie statt bloss des Fingerabdrucks: zum Zurueckholen wird
  // der urspruengliche Zeitraum samt Projekt gebraucht, nicht nur die Auskunft,
  // DASS sich etwas geaendert hat.
  const zustandVorher = new Map(localBookings.value.map((b: any) => [b.id, { ...b }]))
  let undoGepusht = false
  let primaerParams: any = null

  if (params.selected_bid) {
    const old = localBookings.value.find((b: any) => b.id === params.selected_bid)
    if (old) {
      primaerParams = { ...params, booking_action: old.project_id, selected_pid: old.project_id, firstDay: old.start, lastDay: old.end, newpstart: null, newpend: null }
      pushUndo({ type: 'booking', params: primaerParams })
      undoGepusht = true
    }
  }
  const previousIds = new Set(localBookings.value.map((b: any) => b.id))

  // Optimistic update for new bookings (no project date extension, not a clear action)
  const isOptimistic = !params.selected_bid && params.booking_action >= 0 && !params.newpstart
  let tempIds: string[] = []
  let previousBookings: any[] = []

  if (isOptimistic) {
    // firstDay/lastDay sind ISO – dasselbe, was der Server gleich zurückliefert.
    const startStr = params.firstDay as string
    const endStr   = params.lastDay as string
    previousBookings = [...localBookings.value]
    const now = Date.now()
    tempIds = (params.selectedResources as number[]).map((_: any, i: number) => `temp-${now}-${i}`)
    localBookings.value = [...localBookings.value, ...(params.selectedResources as number[]).map((uid: number, i: number) => ({
      id: tempIds[i], start: startStr, end: endStr, user_id: uid, project_id: params.booking_action,
    }))]
  } else {
    isLoading.value = true
  }

  sendRequest('/update_bookings', params, function(bookings) {
    isLoading.value = false
    localBookings.value = bookings

    localProjects.value = localProjects.value.map((p: any) => {

      // newpstart/newpend kommen als ISO aus validateProjectDuration – direkt
      // übernehmbar (vorher wurden hier zwei nicht importierte Funktionen
      // aufgerufen, was den Zweig zum ReferenceError machte).
      if (params["selected_pid"] === p.id && params["newpstart"]) {
        return {
          ...p,
          start: params["newpstart"],
          end: params["newpend"]
        }
      }

      return p
    })
    // Welche Buchungen, die es vorher gab, sind verschwunden oder veraendert?
    // Die gerade bearbeitete ist ausgenommen, ihre Aenderung ist ja gewollt.
    const betroffen = [...zustandVorher.values()].filter((alt: any) => {
      if (alt.id === params.selected_bid) return false
      const jetzt = bookings.find((b: any) => b.id === alt.id)
      return !jetzt || bookingSignatur(jetzt) !== bookingSignatur(alt)
    })

    // Zurueckholen laesst sich eine solche Buchung, indem ihr urspruenglicher
    // Zeitraum im urspruenglichen Projekt neu gebucht wird: update_booking
    // verschmilzt beim Buchen im selben Projekt die uebrig gebliebenen Stuecke
    // wieder zusammen (der else-Zweig endet mit b.delete). Damit ist der Fall
    // abgedeckt, den die Leistungsbereiche haeufig gemacht haben - eine Buchung
    // im Bereich schneidet die Hauptbuchung frei, der Spiegel fuellt die Luecke.
    //
    // Zwei Arten bleiben ausgenommen und lassen den Knopf weiter sperren:
    // Urlaub, weil er ueber diesen Weg gar nicht entsteht, und abgeleitete
    // Buchungen - ein Neubuchen erzeugte dort eine eigenstaendige Buchung ohne
    // Bezug zu ihrer Quelle. Siehe TIM-53 und TIM-75.
    const wiederherstellbar = betroffen.every((b: any) =>
      !b.derived_from_id && Number(b.project_id) !== 0)

    if (betroffen.length > 0 && !wiederherstellbar) {
      // Rueckgaengig waere hier eine Falle: es wuerde die neuen Buchungen
      // loeschen und die alten trotzdem nicht zurueckbringen.
      if (undoGepusht) undoStack.value.pop()
      undoGesperrt.value = true
    } else if (betroffen.length > 0) {
      // Der einfache Gegen-Befehl reicht nicht mehr, er beruehrt nur die eine
      // Buchung. Stattdessen ein Eintrag, der auch die freigeschnittenen
      // Stuecke wieder zusammensetzt.
      if (undoGepusht) undoStack.value.pop()
      pushUndo({
        type: 'restore',
        // Abgeleitete Buchungen nicht mitloeschen: sie haengen per Fremd-
        // schluessel an ihrer Quelle und verschwinden mit ihr.
        neu: bookings.filter((b: any) => !previousIds.has(b.id) && !b.derived_from_id).map((b: any) => b.id),
        alt: betroffen.map((b: any) => ({ user_id: b.user_id, project_id: b.project_id, start: b.start, end: b.end })),
        primaer: primaerParams,
      })
    } else if (!params.selected_bid && params.booking_action !== -1) {
      const newIds = bookings.filter((b: any) => !previousIds.has(b.id)).map((b: any) => b.id)
      if (newIds.length > 0) pushUndo({ type: 'newBooking', bookingIds: newIds })
    }
    if (afterSuccess) afterSuccess();
    else updatePlanner();
  }, function(response) {
    if (isOptimistic) localBookings.value = previousBookings
    isLoading.value = false
    alert(response.error);
    updatePlanner();
  });
}

function projectChangeDone(params) {
	undoGesperrt.value = false
	const old = localProjects.value.find((p: any) => p.id === params.selected_pid)
	let undoGepusht = false
	if (old) {
		pushUndo({ type: 'projectChange', params: { ...params, firstDay: old.start, lastDay: old.end } })
		undoGepusht = true
	}
	isLoading.value = true
	sendRequest('/change_project_date', params, function(response) {
		isLoading.value = false
		localProjects.value = response["projects"]
		let affected_bookings = response["affected_bookings"]
		modalMessage.value = "Folgende Buchungen sind betroffen"
		modalColsItems.value = colscollisions
		modalItems.value = affected_bookings
		console.log("affected_bookings=" + JSON.stringify(affected_bookings))
		if (affected_bookings.length > 0) {
			// Der Zeitraumwechsel hat Buchungen gekuerzt oder geloescht. Das
			// Rueckgaengig setzt nur den Zeitraum zurueck und laesst die
			// Buchungen verschwunden - also gar nicht erst anbieten (TIM-53).
			if (undoGepusht) undoStack.value.pop()
			undoGesperrt.value = true
			confirmModal.value.open();			
		}
    updatePlanner()
	}, function(response) {
		isLoading.value = false
		alert(response['error']);
    updatePlanner()
	});
}

function performUndo() {
  const action = undoStack.value.pop()
  if (!action) return
  isUndoing = true
  isLoading.value = true
  if (action.type === 'booking') {
    sendRequest('/update_bookings', action.params, function(bookings) {
      isLoading.value = false
      localBookings.value = bookings
      updatePlanner()
      isUndoing = false
    }, function(response) {
      isLoading.value = false
      alert(response.error)
      updatePlanner()
      isUndoing = false
    })
  } else if (action.type === 'newBooking') {
    const token = (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content
    Promise.all(
      action.bookingIds.map((id: number) =>
        fetch(`/bookings/${id}`, { method: 'DELETE', headers: { 'X-CSRF-Token': token, 'Accept': 'application/json' } })
      )
    ).then(() => {
      sendRequest('/bookings.json', {}, function(bookings) {
        isLoading.value = false
        localBookings.value = bookings
        updatePlanner()
        isUndoing = false
      }, function() { isLoading.value = false; isUndoing = false }, 'GET')
    }).catch(() => {
      isLoading.value = false
      isUndoing = false
      alert('Fehler beim Rückgängig machen')
    })
  } else if (action.type === 'projectChange') {
    sendRequest('/change_project_date', action.params, function(response) {
      isLoading.value = false
      localProjects.value = response["projects"]
      updatePlanner()
      isUndoing = false
    }, function(response) {
      isLoading.value = false
      alert(response['error'])
      updatePlanner()
      isUndoing = false
    })
  } else if (action.type === 'restore') {
    // Erst die neu entstandenen Buchungen weg, dann die alten Zeitraeume neu
    // buchen. Nacheinander und nicht parallel: jeder Aufruf von
    // /update_bookings schneidet frei, was ihm im Weg liegt - gleichzeitig
    // gestartet wuerden sie sich gegenseitig kappen.
    const token = (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content
    const buchen = (p: any) => new Promise<void>((fertig, fehler) => {
      sendRequest('/update_bookings', p, () => fertig(),
                  (r: any) => fehler(new Error(r?.error || 'Fehler beim Rückgängig machen')))
    })
    ;(async () => {
      try {
        for (const id of action.neu) {
          await fetch(`/bookings/${id}`, { method: 'DELETE',
            headers: { 'X-CSRF-Token': token, 'Accept': 'application/json' } })
        }
        if (action.primaer) await buchen(action.primaer)
        for (const b of action.alt) {
          await buchen({
            isproject: false,
            booking_action: b.project_id,
            selected_pid: b.project_id,
            selected_bid: null,
            firstDay: b.start,
            lastDay: b.end,
            selectedResources: [b.user_id],
            shift: false,
            changedir: false,
          })
        }
        sendRequest('/bookings.json', {}, function(bookings) {
          isLoading.value = false
          localBookings.value = bookings
          updatePlanner()
          isUndoing = false
        }, function() { isLoading.value = false; isUndoing = false }, 'GET')
      } catch (e: any) {
        isLoading.value = false
        isUndoing = false
        alert(e?.message || 'Fehler beim Rückgängig machen')
        updatePlanner()
      }
    })()
  } else if (action.type === 'deletedBooking') {
    const b = action.booking
    const params = {
      isproject: false,
      booking_action: b.project_id,
      selected_pid: b.project_id,
      selected_bid: null,
      firstDay: b.start,
      lastDay: b.end,
      selectedResources: [b.user_id],
      shift: false,
      changedir: false,
    }
    sendRequest('/update_bookings', params, function(bookings) {
      isLoading.value = false
      localBookings.value = bookings
      updatePlanner()
      isUndoing = false
    }, function(response) {
      isLoading.value = false
      alert(response.error)
      isUndoing = false
    })
  }
}

function deleteSelectedBooking() {
  const selected = (document.querySelector('.task.highlight-bar') || document.querySelector('.task.editable')) as HTMLElement | null
  if (!selected) return

  const parts = selected.id.split('-')
  if (parts.length < 3) return  // Projektzeile, keine Buchung

  const bookingId = parseInt(parts[parts.length - 1])
  if (isNaN(bookingId)) return

  const booking = localBookings.value.find((b: any) => b.id === bookingId)
  if (!booking) return

  pushUndo({ type: 'deletedBooking', booking: { ...booking } })
  localBookings.value = localBookings.value.filter((b: any) => b.id !== bookingId)
  isLoading.value = true
  closePopup()

  sendRequest(`/bookings/${bookingId}`, {}, function() {
    isLoading.value = false
    updatePlanner()
  }, function(response) {
    isLoading.value = false
    undoStack.value.pop()
    localBookings.value.push(booking)
    alert(response.error || 'Fehler beim Löschen')
    updatePlanner()
  }, 'DELETE')
}

function handleDateUpdate(startdate, enddate) {
	console.log("handleDateUpdate startdate, enddate=" + startdate +  " " +  enddate);
	
	let startDate = fromIso(fromGerman(startdate));
	let endDate   = fromIso(fromGerman(enddate));

	const rect = document.querySelector(".selection-rectangle") as HTMLElement | null;
	if (!rect) {
		return;
	}

	const x = xScaleRef.value;
	if (!x) return;

	// Die linke Kante aus dem Startdatum berechnen, nicht aus dem bestehenden
	// Rechteck ablesen: sonst bleibt sie beim Ändern des Starts stehen und nur die
	// Breite wächst – sichtbar wandert dann das Ende statt des Anfangs.
	// setDim rastet ohnehin auf ganze Tagesspalten, der 1-h-Versatz zwischen
	// Achsen-Raster (lokal) und fromIso (UTC) fällt dabei weg.
	const newleft = cleanx(x, startDate);
	const newWidth = cleanx(x, endDate) - newleft + getWidthPerDay(printProject.value !== null, view.zoomWidthPerDay);
	setDim(rect, newleft, parseFloat(rect.style.top), newWidth, parseFloat(rect.style.height), dayWidth, getRowHeight(printProject.value !== null));
}

function handleCancel() {
   console.log("reload in D3Planner")
   emit('reload')
}

function closeSelection() {
  removeSelections()
  document.getElementById("timesheet").classList.remove("disable-selection");
  const selectionLayer = document.getElementById('selection-layer');
  if (!selectionLayer) {
	return
  }
  let sel = selectionLayer.querySelector('.selection-rectangle');
  if (sel) {
    sel.remove();
	selectionPopupRef.value?.handleSelectionClose();
  }		
}  

function renderTimesheet() {
	console.log("startDateStr=" + startDateStr)
	console.log("startDate=" + startDate.value)
	console.log("endDate=" + endDate.value)

	endDate.value = nextDay(endDate.value);

	let widthPerDay= getWidthPerDay(printProject.value !== null, view.zoomWidthPerDay)
    const totalDays = Math.round((endDate.value.getTime() - startDate.value.getTime()) / dayMs);

    const x = d3.scaleUtc().domain([startDate.value, endDate.value]).range([0, totalDays * widthPerDay]);

    xScaleRef.value = x;

    let dayWidth = cleanx(x, new Date(2024, 0, 2)) - cleanx(x, new Date(2024, 0, 1));

	const timesheet = document.getElementById("timesheet");
	timesheet.style.width = `${totalDays * widthPerDay}px`;

	const sidebar = document.getElementById("sidebar");
	const mainScrollArea = document.getElementById("main-scroll-area");

    const days = d3.utcDay.range(startDate.value, endDate.value);
	daysRef.value = days;

	//console.log("holidays=" + JSON.stringify(holidays))


	const selectionLayer = document.getElementById('selection-layer');

	document.addEventListener("keydown", e => {
		if (e.code === "Escape") {
			closeSelection();
		}
		if ((e.ctrlKey || e.metaKey) && e.key === 'z') {
			e.preventDefault()
			performUndo()
		}
		if (e.code === 'Backspace' && !(e.target as Element).closest('input, textarea, select, [contenteditable]')) {
			e.preventDefault()
			deleteSelectedBooking()
		}
	})


  let longPressTimer: number
	let startX = 0
	let startY = 0
	const LONG_PRESS_THRESHOLD = 500 // ms
	const MOVE_THRESHOLD = 10 // pixels

	if (printProject.value) {
	  //no need to allow listeners
	  return;
	}
	timesheet.addEventListener("pointerdown", e => {
	  if ((e.target as Element).closest(".task") || (e.target as Element).closest(".selection-rectangle") || (e.target as Element).closest(".project-row")) return;

    window.__POINTER_DOWN__ = true;

	  document.querySelectorAll(".task.editable").forEach(t => t.classList.remove("editable"));

	  startX = e.clientX
	  startY = e.clientY
	  let moved = false
	  let longPressTriggered = false

	  // Langes Druecken ist eine Geste fuer Finger und Stift - mit der Maus zieht
	  // man auf, sobald man sich bewegt. Vorher lief der Zeitgeber fuer jedes
	  // Eingabegeraet, man musste also auch am Rechner erst warten.
	  const istZeigegeraet = e.pointerType === "mouse"

	  const auswahlBeginnen = () => {
	    longPressTriggered = true
	    closeSelection()
	    selectionPopupRef.value?.handleSelectionClose();
	    startSelectionRectangle(e)
	  }

	  if (!istZeigegeraet) {
	    longPressTimer = window.setTimeout(auswahlBeginnen, LONG_PRESS_THRESHOLD)
	  }

	  const onPointerMove = (ev: PointerEvent) => {
	    const dx = ev.clientX - startX
	    const dy = ev.clientY - startY
	    if (Math.hypot(dx, dy) > MOVE_THRESHOLD) {
	      moved = true
	      clearTimeout(longPressTimer)
	      timesheet.removeEventListener("pointermove", onPointerMove)
	      timesheet.removeEventListener("pointerup", onPointerUp)
	      // Mit der Maus ist genau das die Geste zum Aufziehen. Beim Finger
	      // bedeutet Bewegung dagegen scrollen - dort bleibt es beim langen
	      // Druecken, und der Zeitgeber ist oben schon abgeraeumt.
	      if (istZeigegeraet) auswahlBeginnen()
	    }
	  }

	  const onPointerUp = (ev: PointerEvent) => {
	    clearTimeout(longPressTimer)
	    timesheet.removeEventListener("pointermove", onPointerMove)
	    timesheet.removeEventListener("pointerup", onPointerUp)

      window.__POINTER_DOWN__ = false;

	    if (!longPressTriggered && !moved) {
	      // Short tap / click
	      closeSelection()
	      startSelectionRectangle(ev, true)
	    }
	    // else: either long press triggered or user dragged → do nothing
	  }

	  timesheet.addEventListener("pointermove", onPointerMove)
	  timesheet.addEventListener("pointerup", onPointerUp)
	})


	// Assume `closeSelection()` is your deselect callback
	function enableTouchDeselect(timesheetEl: HTMLElement) {
	  const onTouchStart = (e: TouchEvent) => {
	    // Only trigger if selection is active and user taps outside rectangle
	    const target = e.target as HTMLElement
	    if (!target.closest(".selection-rectangle")) {
	      closeSelection()
	      removeListeners()
	    }
	  }

	  const removeListeners = () => {
	    timesheetEl.removeEventListener("touchstart", onTouchStart)
	  }

	  timesheetEl.addEventListener("touchstart", onTouchStart)
	}

	// Usage: when selection is active on touch devices
	function onSelectionActivated() {
	  if ("ontouchstart" in window) {
	    enableTouchDeselect(timesheet)
	  }
	}

		
	timesheet.addEventListener('contextmenu', e => {
	  e.preventDefault(); // block long-press context menu
	});

	function startSelectionRectangle(e, immediate = false) {
	  //enableTouchDeselect(timesheet);
	  closePopup();
	  timesheet.classList.add("disable-selection");
	  const rect = document.createElement("div");
	  const openPopup = () => {
		  let b = box2int({x: rect.style.left,
			                 y: rect.style.top,
						           width: rect.style.width,
						          height: rect.style.height });
	    console.log("b=" + JSON.stringify(b));
		  selectionPopupRef.value?.handleSelectionComplete(b);
	  } 

	  rect.removeEventListener("click", openPopup);
	  rect.className = "selection-rectangle";
	  selectionLayer.appendChild(rect);

	  const containerRect = selectionLayer.getBoundingClientRect();
	  const startX = e.clientX - containerRect.left;
	  const startY = e.clientY - containerRect.top;
	  console.log("startX=" + startX + " startY=" + startY)

	  const rh = getRowHeight(printProject.value !== null)
	  setDim(rect, startX, startY, dayWidth, rh, dayWidth, rh);

	  // Vor dem immediate-Zweig, weil addResizeHandlesTo darunter darauf zugreift:
	  // stuende die Definition weiter unten, waere container beim fruehen return
	  // nie ausgefuehrt und der spaetere Griff-Handler liefe in einen
	  // ReferenceError.
	  const container = document.querySelector('.main-scroll-area');

    let initialScroll = container.scrollLeft

	  if (immediate) {
		  // Tag unter dem Tap als ISO – Vergleich gegen den Projektzeitraum (ebenfalls ISO).
		  let clickDay = xToIso(x, startX);
		  let p = getProjectFromRow(e, displayProjects.value);
		  if (!p || clickDay < p.start || clickDay > p.end) {
			  closeSelection();
			  return;
	  	}
		  // Auch die Ein-Tages-Auswahl aus einem einfachen Klick bekommt Anfasser.
		  // Vorher hingen die nur am Loslassen nach einem Zug, den es hier nicht
		  // gibt - die Box liess sich danach nicht mehr veraendern (TIM-9).
		  addResizeHandlesTo(rect);
		  openPopup();
		  return;		
	  }

	  const onMove = e2 => {
		  handleAutoScroll(e2);

		  const scrollDiff = container.scrollLeft - initialScroll;

	    const dx = e2.clientX - containerRect.left + scrollDiff;
	    const dy = e2.clientY - containerRect.top;

	    const left = Math.min(startX, dx);
	    const top = Math.min(startY, dy);
	    const width = Math.max(Math.abs(dx - startX), dayWidth);
	    const height = Math.max(Math.abs(dy - startY), rh);

	    setDim(rect, left, top, width, height, dayWidth, rh)
	  }

	  const onUp = e2 => {
	    timesheet.removeEventListener("pointermove", onMove);
	    timesheet.removeEventListener("pointerup", onUp);
      window.__POINTER_DOWN__ = false;
	    snapSelectionRectangleToGrid(rect);
	    rect.addEventListener("click", openPopup);
	  };

	  timesheet.addEventListener("pointermove", onMove);
	  timesheet.addEventListener("pointerup", onUp);

	  function snapSelectionRectangleToGrid(rect) {
	    const left = parseFloat(rect.style.left);
	    const top = parseFloat(rect.style.top);
	    const width = Math.max(parseFloat(rect.style.width), dayWidth);
	    const height = Math.max(parseFloat(rect.style.height), rh);

	    setDim(rect, left, top, width, height, dayWidth, rh);
	  	  
	    addResizeHandlesTo(rect);
	    openPopup();
	  }

	  function addResizeHandlesTo(rect) {
	    // snapSelectionRectangleToGrid läuft nach jedem Loslassen, auch nach einem
	    // Resize – ohne diesen Riegel käme jedes Mal ein weiterer Satz Griffe dazu.
	    if (rect.querySelector('.resize-handle')) return;

	    // Nur die Ecken: Die Kantengriffe lagen dicht an den Ecken und waren
	    // schwer zu treffen, ohne dass man die gewuenschte Ecke verfehlt.
	    const positions = ['nw', 'ne', 'se', 'sw'];

	    for (const pos of positions) {
	      const handle = document.createElement("div");
	      handle.className = `resize-handle ${pos}`;
	      rect.appendChild(handle);

	      setupResizeHandle(handle, rect, pos);
	    }
      }

	  function setupResizeHandle(handle, rect, position) {
	    handle.addEventListener("pointerdown", e => {
	      e.stopPropagation();
	      e.preventDefault();

        selectionPopupRef.value?.handleSelectionClose();
        window.__POINTER_DOWN__ = true;
        
        let initialScroll = container.scrollLeft
	      const startX = e.clientX;
	      const startY = e.clientY;
	      const startLeft = parseFloat(rect.style.left);
	      const startTop = parseFloat(rect.style.top);
	      const startWidth = parseFloat(rect.style.width);
	      const startHeight = parseFloat(rect.style.height);

		    const onMove = e2 => {
		      handleAutoScroll(e2); 
			
			    const scrollDiff = container.scrollLeft - initialScroll;

          const dx = (e2.clientX - startX) + scrollDiff;
			    const dy = e2.clientY - startY;
			
			    let newLeft = startLeft;
			    let newTop = startTop;
			    let newWidth = startWidth;
			    let newHeight = startHeight;

			    if (position.includes("e")) {
				    newWidth = startWidth + dx;
			    }
			    if (position.includes("s")) {
				    newHeight = startHeight + dy;
		      }
			    if (position.includes("w")) {
				    newLeft = startLeft + dx;
			    }
			    if (position.includes("n")) {
				    newTop = startTop + dy;
			    }

			    // Aufs Raster runden. Beim West- und Nordgriff wird NUR die bewegte
			    // Kante gerundet, die Ausdehnung danach aus der festen Kante
			    // abgeleitet. Vorher wurden Position und Groesse einzeln gerundet -
			    // dabei wanderte die gegenueberliegende Kante mit, obwohl man sie gar
			    // nicht angefasst hatte (TIM-9, vierter Punkt).
			    newLeft = Math.round(newLeft / dayWidth) * dayWidth;
			    newTop = Math.round(newTop / rh) * rh;

			    newWidth = position.includes("w")
			      ? (startLeft + startWidth) - newLeft
			      : Math.round(newWidth / dayWidth) * dayWidth;
			    newHeight = position.includes("n")
			      ? (startTop + startHeight) - newTop
			      : Math.round(newHeight / rh) * rh;

			    // Mindestgroesse. Beim West-/Nordgriff muss dabei die bewegte Kante
			    // zurueck, sonst verschiebt sich doch wieder die feste.
			    if (newWidth < dayWidth) {
			      if (position.includes("w")) newLeft = (startLeft + startWidth) - dayWidth;
			      newWidth = dayWidth;
			    }
			    if (newHeight < rh) {
			      if (position.includes("n")) newTop = (startTop + startHeight) - rh;
			      newHeight = rh;
			    }

			    setDim(rect, newLeft, newTop, newWidth, newHeight, dayWidth, rh);
		    };

	      const onUp = () => {
	        document.removeEventListener("pointermove", onMove);
	        document.removeEventListener("pointerup", onUp);
	        snapSelectionRectangleToGrid(rect);
	      };

	      document.addEventListener("pointermove", onMove);
	      document.addEventListener("pointerup", onUp);
	    });
	  }
	}
	
  let scrollDay = new Date();
  if (view.zoomVal === 4) {
     scrollDay = new Date(view.zoomStart);
  }

  	// add a vertical line for today's date'
	if (!printProject.value) {
	  positionTodayLine("today-line", x, scrollDay);
	}
	
	scrollToDate(x, scrollDay, view);
}


function handlePrintAction(project, start, end) {
   console.log("printview p=" + project.name + " start=" + start + " end=" + end)

   printProject.value = project;
   printStart.value = start;
   printEnd.value = end;
}

function handleRestorePlanner() {
   printProject.value = null;
   printStart.value = null;
   printEnd.value = null;
}


// Zeigergeste am Fenster mitschreiben - das automatische Scrollen am Rand
// braucht die Auskunft, ob gerade noch gedrueckt wird.
//
// Benannte Funktionen und ein gemerkter Zeitgeber, damit beides beim Abbau
// wieder wegkommt: App.vue erhoeht bei jedem reload() den key des Planners und
// erzwingt so einen Neuaufbau. Mit anonymen Funktionen und einem freilaufenden
// setInterval sammelten sich vier Zuhoerer UND ein 50-ms-Zeitgeber pro
// Neuaufbau an - nach zehn Ladevorgaengen zehn Zeitgeber nebeneinander.
function zeigerGedrueckt() { window.__POINTER_DOWN__ = true; }
function zeigerLos()       { window.__POINTER_DOWN__ = false; }

let autoScrollTimer: number | null = null;

onMounted(() => {
  window.__POINTER_DOWN__ = false;

  window.addEventListener("pointerdown", zeigerGedrueckt);
  window.addEventListener("pointerup", zeigerLos);
  window.addEventListener("pointercancel", zeigerLos);
  // iPad fallback (important!)
  window.addEventListener("touchend", zeigerLos);

  autoScrollTimer = window.setInterval(() => {
    if (!window.__POINTER_DOWN__) {
      stopAutoScroll();
    }
  }, 50);

  renderTimesheet();
});

onUnmounted(() => {
  window.removeEventListener("pointerdown", zeigerGedrueckt);
  window.removeEventListener("pointerup", zeigerLos);
  window.removeEventListener("pointercancel", zeigerLos);
  window.removeEventListener("touchend", zeigerLos);
  if (autoScrollTimer !== null) {
    clearInterval(autoScrollTimer);
    autoScrollTimer = null;
  }
});
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  font-family: sans-serif;
}

.scheduler-wrapper {
  display: grid;
  grid-template-rows: auto 1fr;
  width: fit-content;
  /* 100vh ist auf dem Telefon die Fensterhoehe OHNE Browserleiste. Solange die
     Leiste sichtbar ist, wird der Planer damit hoeher als der Platz, den er hat;
     weil body nicht scrollen darf, schiebt der Browser den Inhalt selbst, und
     die Kopfzeile mit der Zeitachse rutscht oben heraus - unerreichbar.
     dvh ist die tatsaechlich sichtbare Hoehe und faehrt mit der Leiste mit.
     Die vh-Zeile bleibt als Rueckfall fuer Browser ohne dvh. */
  height: 100vh;
  height: 100dvh;
  position: relative;
  overflow: visible;
}

.corner {
  grid-column: 1;
  grid-row: 1;
  background: #f0f0f0;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  height: 96px;
}

#sidebar {
  grid-column: 1;
  grid-row: 2;
  overflow-y: auto;
  background: #f0f0f0;
  border-right: 1px solid #ccc;
  font-size: 12px;
  padding-bottom: 6px;
}

#sidebar.printview {
  background: white !important;
  border-top: 2px solid black;
}



/* Weiss statt grau, und nur eine Linie oben: die Projektzeile soll die Liste
   gliedern, nicht als eigener Kasten aus ihr herausstehen. Der Farbbalken links
   traegt die Zugehoerigkeit, die Linie oben den Schnitt. */
.sidebar-group {
  font-weight: bold;
  background: #fff;
  padding: 4px;
  cursor: pointer;
  user-select: none;
}

.sidebar-resource {
  padding-left: 12px;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.main-scroll-area {
  grid-column: 2;
  grid-row: 1 / span 2;
  overflow: auto;
  position: relative;
  background-color: white;
}

.main-scroll-area {
  scrollbar-width: auto;           /* "auto" | "thin" */
  scrollbar-color: #999 #e5e5e5;   /* thumb | track */
}

/* WebKit (Chrome, Edge, Safari) */
.main-scroll-area::-webkit-scrollbar {
  height: 66px;   /* horizontal scrollbar thickness only */
  width: auto;    /* vertical stays default */
}

.main-scroll-area::-webkit-scrollbar-track {
  background: #e5e5e5;
}

.main-scroll-area::-webkit-scrollbar-thumb {
  background: #999;
  border-radius: 8px;
  border: 3px solid #e5e5e5; /* optional padding effect */
}

.main-scroll-area::-webkit-scrollbar-thumb:hover {
  background: #777;
}
.timesheet {
  position: relative;
  width: max-content;

  -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}

.corner {
  grid-column: 1;
  grid-row: 1;
  background: #f0f0f0;
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
}

#today-button {
  padding: 4px 12px;
  font-size: 12px;
  cursor: pointer;
}

.task.editable .resize-handle {
  display: block;
}

.resize-handle {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 24px; /* bigger touch area */
  margin: 0 -10px; /* overlap into task */
  z-index: 2;
  background: transparent;
  cursor: ew-resize;
  display: none;
  touch-action: none; /* prevent unwanted pinch-zoom or pan */
}

.resize-handle::before {
  content: "";
  position: absolute;
  top: 25%;
  bottom: 25%;
  width: 4px;
  background-color: #666;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 2px;
}

.resize-handle.left {
  left: -3px;
}

.resize-handle.right {
  right: -3px;
}

.task.editable .drag-handle {
  display: block;
}

.drag-handle {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  background-color: #444;
  transform: translate(-50%, -50%);
  border-radius: 4px;
  cursor: grab;
  z-index: 10;
  touch-action: none;
}

.drag-handle:active {
  cursor: grabbing;
}

.selection-layer {
  position: absolute;  /* or relative if it's already inside a positioned container */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: visible;
  z-index: 1000;  /* lower than .selection-rectangle (z: 5 or 10) */
  pointer-events: none; /* so other things like tasks remain clickable */

   -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
  touch-action: none;
}


.selection-rectangle {
  position: absolute;
  /* Grauton statt des kraeftigen Blaus - die Auswahl soll den Plan darunter
     nicht ueberdecken. Akzent bleibt den Anfassern vorbehalten. */
  border: 2px dashed #6b7280;
  background-color: rgba(107, 114, 128, 0.08);
  pointer-events: auto;
  z-index: 1000;
}

.selection-rectangle .resize-handle {
  position: absolute;
  /* Groesser als vorher (24px), damit man sie auf dem Tablet sicher trifft,
     dafuer weiss mit farbigem Rand statt flaechig rot. */
  width: 28px;
  height: 28px;
  background: #ffffff;
  border: 2px solid #6b7280;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  z-index: 1010;
  display: block;
  pointer-events: auto;
  box-sizing: border-box;
}

.timesheet.disable-selection {
  touch-action: none;
  user-select: none;
}

.highlight-bar {
  border: 3px solid black !important;
}

/* Trenner zwischen aktiven und potentiellen Projekten. Dezent gehalten: eine
   Linie und eine kleine Beschriftung, keine Flaeche - die Liste soll gegliedert
   wirken, nicht in zwei Kaesten zerfallen. Die Hoehe steht fest, weil
   Seitenleiste und Zeitstrahl zeilenweise aneinander haengen. */
.gruppentrenner {
  height: 26px;
  box-sizing: border-box;
  border-top: 1px solid #c3ccd6;
}

.sidebar-trenner {
  display: flex;
  align-items: center;
  padding: 0 0 0 8px;
  font-size: 10px;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: #8b96a3;
  white-space: nowrap;
  overflow: hidden;
}

.print-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  /* Match this width to your sidebar/corner width */
  width: 250px; 
  height: 80px;
  background: #f8f9fa;
  border-top: 2px solid #ccc;
  border-right: 1px solid #ccc;
  z-index: 9999; /* Ensure it's above everything */
  display: flex;
  align-items: center;
  padding: 0 15px;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
}

.footer-content {
  display: flex;
  gap: 12px;
}

.footer-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #22c55e; /* green-500 */
  color: white;
  border: none;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 10px;
  font-weight: bold;
  transition: transform 0.1s;
}

.footer-btn:active {
  transform: scale(0.95);
}

.footer-btn.secondary {
  background: #64748b; /* slate-500 */
}


/* Positioning */
.selection-rectangle .resize-handle.nw { top: -24px; left: -12px; cursor: nwse-resize; }
.selection-rectangle .resize-handle.ne { top: -24px; right: -12px; cursor: nesw-resize; }
.selection-rectangle .resize-handle.sw { top: 100%;  left: -12px; cursor: nesw-resize; }
.selection-rectangle .resize-handle.se { top: 100%;  right: -12px; cursor: nwse-resize; }

.selection-rectangle .resize-handle.n {
  left: 50%;
  transform: translate(-50%, 0);
}

.selection-rectangle .resize-handle.n  { top: -24px; left: 50%; transform: translateX(-55%); cursor: ns-resize; }
.selection-rectangle .resize-handle.s  { top: 100%; left: 50%; transform: translateX(-55%); cursor: ns-resize; }
.selection-rectangle .resize-handle.e  { right: -12px; top: 50%; transform: translateY(-50%); cursor: ew-resize; }
.selection-rectangle .resize-handle.w  { left: -12px; top: 50%; transform: translateY(-50%); cursor: ew-resize; }



.undo-btn-enter-active, .undo-btn-leave-active { transition: opacity 0.2s, transform 0.2s; }
.undo-btn-enter-from, .undo-btn-leave-to { opacity: 0; transform: scale(0.7); }

.web-print-header {
  padding: 6px 16px 4px;
  background: white;
  border-bottom: 1px solid #ddd;
  font-family: helvetica, sans-serif;
}

.web-print-title {
  font-size: 13px;
  font-weight: bold;
}

.web-print-meta {
  font-size: 11px;
  color: #555;
  margin-top: 2px;
}

.web-print-sep {
  margin-left: 16px;
  margin-right: 4px;
}
</style>
